<div class="flex flex-col">
  <div class="md:mx-auto">
    <button class="focus:outline-none">
      <img (click)="openAndCloseMenu()" src="assets/svg/burger-menu.svg" class="
          h-16
          my-8
          mx-auto
          focus:outline-none
          rounded-full
          hover:bg-yellow-500 hover:bg-opacity-20
        " />
    </button>
  </div>
</div>
<!-- ALL MENU -->
<div id="menu" class="
    flex-col
    justify-center
    hidden
    backdropFirefox
    backdrop-filter backdrop-blur-3xl
    fixed
    h-screen
    overflow-y-auto
    lg:overflow-y-visible
    top-0
    left-0
    z-50
  ">
  <div class="relative md:mt-4 z-50 overflow-auto">
    <div class="flex mx-4 h-16 md:h-24">
      <!-- HEADER MENU -->
      <div>
        <button class="focus:outline-none lg:ml-12">
          <img (click)="openAndCloseMenu()" src="assets/svg/cross.svg" class="h-12 md:h-14 mt-4" />
        </button>
      </div>
      <div class="
          text-xs
          sm:text-sm
          md:text-base
          lg:text-2xl
          xl:text-3xl
          font-semibold
          ml-4
          mt-8
        ">
        <p>Vous êtes...</p>
      </div>
    </div>
    <!-- SEARCH BAR MENU -->
    <div class="w-10/12 mx-auto block md:hidden">
      <app-search (IsClicked)="checkIfIhaveToCloseMenu($event)"></app-search>
    </div>
    <div class="xl:flex lg:grid lg:grid-cols-3 xl:h-screen xl:w-screen">
      <!-- APPRENTICE CARD MENU -->
      <div class="
          items-center
          text-center
          rounded-3xl
          justify-between
          md:justify-around
          lg:justify-center
          bg-transparent
          shadow-lg
          flex
          xl:flex-col
          xl:h-4/5
          xl:w-1/4
          h-1/6
          mt-4
          w-4/5
          mx-auto
          p-4
          minHeigth
        ">
        <div>
          <img class="h-32 md:h-40 h-99 md:mx-auto" src="../../../../assets/svg/avatar-18.svg" />
        </div>
        <div>
          <p class="
              text-xs
              sm:text-sm
              md:text-base
              lg:text-2xl
              font-bold
              capitalize
              lg:mt-8
            ">
            un apprenti
          </p>
          <app-primary-button iconClasses="hidden" (click)="goToApprenticePage()"
            additionalClasses="mx-auto mt-8 button-menu lg:w-48" text="Continuer" paragraphClasses="mr-0">
          </app-primary-button>
        </div>
      </div>
      <!-- EMPLOYER CARD MENU -->
      <div class="
          items-center
          text-center
          rounded-3xl
          justify-between
          md:justify-around
          lg:justify-center
          bg-transparent
          shadow-lg
          flex
          h-1/6
          mt-4
          w-4/5
          mx-auto
          p-4
          xl:flex-col
          xl:h-4/5
          xl:w-1/4
          minHeigth
        ">
        <div>
          <img class="h-36 md:h-40 h-99 md:mx-auto" src="assets/svg/avatar-16.svg" />
        </div>
        <div>
          <p class="
              text-xs
              sm:text-sm
              md:text-base
              lg:text-2xl
              font-bold
              capitalize
              lg:mt-8
            ">
            un employeur
          </p>
          <app-primary-button iconClasses="hidden" (click)="goToEmployerPage()"
            additionalClasses="mx-auto justify-center mt-8 button-menu lg:w-48" text="Continuer"
            paragraphClasses="mr-0"></app-primary-button>
        </div>
      </div>
      <!-- UFA CARD MENU -->
      <div class="
          items-center
          text-center
          rounded-3xl
          justify-between
          md:justify-around
          lg:justify-center
          bg-transparent
          shadow-lg
          flex
          h-1/6
          mt-4
          w-4/5
          mx-auto
          p-4
          xl:flex-col
          xl:h-4/5
          xl:w-1/4
          minHeigth
        ">
        <div>
          <img class="h-36 md:h-40 h-99 md:mx-auto" src="assets/svg/avatar-19.svg" />
        </div>
        <div>
          <p class="
              text-xs
              sm:text-sm
              md:text-base
              lg:text-2xl
              font-bold
              capitalize
              lg:mt-8
            ">
            une école
          </p>
          <app-primary-button iconClasses="hidden" (click)="goToUfaPage()"
            additionalClasses="mx-auto mt-8 button-menu lg:w-48" text="Continuer" paragraphClasses="mr-0">
          </app-primary-button>
        </div>
      </div>
    </div>
    <!-- FOOTER MENU -->
    <div class="footer-menu text-center my-4 lg:hidden">
      <p (click)="goToTraining()">Nos formations</p>
      <p (click)="goToAboutPage()">Qui sommes-nous ?</p>
      <p (click)="goToContactPage()">Contactez-nous</p>
    </div>
  </div>
</div>